import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nationalitiesPipe'
})

export class NationalitiesPipe implements PipeTransform {
  transform(nationalities: object[], value: string) {
    if (!value) {
      return nationalities
    }
    return nationalities.filter(item => item['Name'].toLowerCase().indexOf(value) !== -1)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/pipes/nationalities-filter.pipe.ts